import { SliderCustom } from './styled';

type CarouselProps = {
  settings: any;
  children: any;
};

const Carousel = ({ children, settings }: CarouselProps) => {

  return (
    <SliderCustom {...settings}>
      {children}
    </SliderCustom>
  );
}

export default Carousel;
